import React from "react";
import {connect} from "react-redux";
import {parse} from "query-string";
import Validator from "validator";
import PropTypes from "prop-types";

import {setNewPassword} from "./actions/userAction";
import {Layout} from "../../shared/components/Layout";
import {InputFieldGroup} from "../../shared/components/InputFieldGroup";
import {MIN_PW_LENGTH} from "./constants";
import {
  NOTIFICATION_ERROR,
  NOTIFICATION_SUCCESS
} from "../../shared/modules/notification/constants";
import * as notificationAction
  from "../../shared/modules/notification/actions/notificationsAction";
import {ROUTER_USER_LOGIN} from "../../shared/constants/routers";


class SetPassword extends React.Component {

  static propTypes = {
    email: PropTypes.string,
    password1: PropTypes.string,
    password2: PropTypes.string,
    reset_token: PropTypes.string,
    errors: PropTypes.object,
    isLoading: PropTypes.bool
  };

  static defaultProps = {
    email: "",
    password1: "",
    password2: "",
    reset_token: "",
    errors: {},
    isLoading: false
  };

  state = {
    email: "",
    password1: "",
    password2: "",
    reset_token: "",
    errors: {},
    isLoading: false
  };

  onSubmit = (evt) => {
    evt.preventDefault();
    this.setState({errors: {}, isLoading: true});

    const {errors, isValid} = this.validateInput(this.state);
    const {email, password1, password2, reset_token} = this.state;

    if (isValid) {
      this.props.dispatch(setNewPassword(email, password1, password2, reset_token))
        .then(() => {
          this.props.history.push(ROUTER_USER_LOGIN);
          this.props.dispatch(
            notificationAction.addNotification(
              __("New password saved successfully"),
              NOTIFICATION_SUCCESS
            )
          )
        })
        .catch((err) => {
          if (typeof err.status === "undefined" && typeof res === "undefined") {
            this.props.dispatch(
              notificationAction.addNotification(
                __("You are offline right now. Please check your internet connection and try again."),
                NOTIFICATION_ERROR
              )
            )
          } else {
            this.props.dispatch(
              notificationAction.addNotification(
                __("Error: Please check your input"),
                NOTIFICATION_ERROR
              )
            );
          }
          this.setState({isLoading: false})
        });
    } else {
      this.setState({errors: errors, isLoading: false});
    }
  };

  componentDidMount() {
    const {reset_token, email} = parse(this.props.location.search);

    this.setState({reset_token: reset_token, email: email});
  }

  validateInput(data) {
    const errors = {};
    let isValid = true;

    if (Validator.isEmpty(data.password1)) {
      errors.password1 = __("Please enter a password.");
      isValid = false;
    }

    if (Validator.isEmpty(data.password2)) {
      errors.password2 = __("Please enter a password.");
      isValid = false;
    }

    if (isValid) {
      if (data.password1.length < MIN_PW_LENGTH) {
        errors.password1 = __("Your password must contain at least %count% characters.")
          .replace('%count%', MIN_PW_LENGTH);
        isValid = false;
      }
    }

    if (isValid) {
      if (data.password1 !== data.password2) {
        errors.password1 = __("Passwords are different.");
        errors.password2 = __("Passwords are different.");
        isValid = false;
      }
    }

    return {errors, isValid: isValid};
  }

  onChange = (event) => {
    this.setState({[event.target.name]: event.target.value});
  };

  render() {
    const {errors, password1, password2} = this.state;

    return (
      <Layout title={__("Set new password")} backLink={ROUTER_USER_LOGIN}>
        <div id="register" className="flexBox direction-column flex">
          <form
            id="login"
            className="flexBox direction-column flex"
            onSubmit={this.onSubmit}
          >
            <InputFieldGroup
              name="password1"
              type="password"
              placeholder={__("Password")}
              value={password1}
              onChange={this.onChange}
              error={errors.password1}
            />
            <InputFieldGroup
              name="password2"
              type="password"
              placeholder={__("Repeat Password")}
              value={password2}
              onChange={this.onChange}
              error={errors.password2}
            />
            <p className="description">
              {__("After you have completed both fields with your new password, you can log in.")}
            </p>
            <button className="buttonPrimary">{__("Reset password")}</button>
          </form>
        </div>
      </Layout>
    );
  }
}

export default connect()(SetPassword);
